"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'conversation.end.failed': 'No se pudo terminar la conversación',
};
